import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { baseApi } from "@/services/api/baseApi";
import { postLogout } from "@/features/auth/authService";
import { broadcastAuthChange } from "@/features/auth/authSync";
import { logOut } from "@/features/auth/authSlice";
import { resetSession } from "@/features/auth/sessionBootstrap";

/**
 * Signs the user out locally even if the server call fails — a network error
 * must not leave someone stuck in a session they asked to end.
 */
export function useLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const doLogout = useCallback(async () => {
    setIsLoggingOut(true);
    try {
      await postLogout();
    } catch (error) {
      console.error("Logout request failed; clearing the session anyway:", error);
    } finally {
      resetSession();
      dispatch(baseApi.util.resetApiState());
      dispatch(logOut());
      broadcastAuthChange("loggedOut");
      setIsLoggingOut(false);
      navigate("/login", { replace: true });
    }
  }, [dispatch, navigate]);

  return { logout: doLogout, isLoggingOut };
}
